var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-header fixed-top"},[_c('h1',{staticClass:"setting-header__heading"},[_c('IconButton',{attrs:{"variant":"flat","icon":"arrow_back_ios"},on:{"click":() => _vm.$router.go(-1)}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }